<div class="card card-tabs">
	<!-- <div class="card-header">
		<h3>{{isHistorical?'Historico de Ordenes de Compra':'Ordenes de Compra'}} <span (click)="createOrder = true;"><i style="font-size: 0.8em;"
					class="a-hover fa fa-plus"><span style="font-family: 'Nunito', sans-serif;">CREAR
						ORDEN DE COMPRA</span></i></span></h3>
	</div> -->
	<div class="card-body">
		<label for="" class="title-history">
			Órdenes de Compra
			<span (click)="createOrder = true;">
				<i style="font-size: 0.5em;"
					class="a-hover fa fa-plus">
					<span style="font-family: 'Nunito', sans-serif;">
						CREAR ORDEN DE COMPRA
					</span>
				</i>
			</span>
		</label>
		<!-- <div class="title-history">
			<h3>{{isHistorical?'Historico de Ordenes de Compra':'Ordenes de Compra'}} 
				<span (click)="createOrder = true;">
					<i style="font-size: 0.5em;"
						class="a-hover fa fa-plus">
						<span style="font-family: 'Nunito', sans-serif;">
							CREAR ORDEN DE COMPRA
						</span>
					</i>
				</span>
			</h3>
		</div> -->

		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5065]" [permissionType]="permissionType.ALL"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5065]" [permissionType]="permissionType.ALL">
				<i class="bx bxs-check-circle"></i>Activos
			</label>

			<input type="radio" [appCheckPermission]="[5065]" [permissionType]="permissionType.ALL" name="pcss3t"
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5065]" [permissionType]="permissionType.ALL">
				<i class="fa fa-xmark-circle"></i>Eliminados
			</label>



		</div>
		<div class="row" [hidden]="history!=0">
			<div class="col" id="list-container">
				<app-purchases-order-active-table [updated]="updated" (downloadOrderPdf)="downloadOrderPdf($event)" (desactiveOrder)="updatedOrderUpdate($event)"></app-purchases-order-active-table>
			</div>
		</div>
		<div class="row" [hidden]="history!=1">
			<div class="col" id="list-container">
				<app-purchases-order-desactive-table [updated]="updated" (activeOrder)="updatedOrderUpdate($event)"></app-purchases-order-desactive-table>
			</div>
		</div>
	</div>

	<!-- <div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<div class="row" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Filtrar</label>
						<div class="input-group input-group-sm">
							<input type="text" id="filter" [(ngModel)]="filterWord"
								placeholder="Filtra pedidos por usuario o bodega" name="filter" class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
				</div>
				<div class="table-responsive" style="margin-bottom: 0;">
					<table class="table table-bordered" style="margin-bottom: 0; margin-top: 1em;">
						<thead>
							<tr>
								<th class="ta">
									Número
								</th>
								<th class="ta">
									Fecha Solicitado
								</th>
                    			<th class="ta">
									Fecha Esperada Entrega
								</th>
								<th class="ta">
									Usuario
								</th>
								<th class="ta">
									Bodega
								</th>
								<th class="ta">
									Estado
								</th>
								<th class="ta" *ngIf="isHistorical">
									Acciones
								</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let order of pagination.filter">
								<tr [class.climbed]="order.climb">
									<td class="ta">
										{{order.id}}
									</td>
									<td class="ta">
										{{convertToString(order.date)}}
									</td>
									<td class="ta">
										{{order.createdBy.email}}
									</td>
									<td class="ta">
										{{order.warehouse.name}}
									</td>
									<td class="ta">
										<i *ngIf="order.climb" tooltip="Orden escalada" class="fa-solid fa-circle-arrow-up"></i>
										{{order.statusName}}
									</td>
									<td class="ta" *ngIf="isHistorical">
										<div style="display: flex; justify-content: center;">
											<div class="container-superposition">
												<span
													#pop="bs-tooltip"
												 *ngIf="order.statusName!='Despachado' && order.statusName!='Anulado'" class="clickeable text-info" tooltip="Despachar" (click)="pop.hide();showOrder(order)">
													<i *ngIf="!showingOrder[order.id]" class="fa-solid fa-people-carry-box"></i>
													<span *ngIf="showingOrder[order.id]"
														class="spinner-border spinner-border-sm"
														aria-hidden="true"></span>
												</span>
												<span
													#pop="bs-tooltip"
												*ngIf="order.statusName!='Nuevo'" class="clickeable text-info" tooltip="Ver historial" (click)="pop.hide();historyOrder(order)">
													<i *ngIf="!showingHistory[order.id]"
														class="fa-solid fa-clock-rotate-left"></i>
													<span *ngIf="showingHistory[order.id]"
														class="spinner-border spinner-border-sm"
														aria-hidden="true"></span>
												</span>
											</div>
										</div>
									</td>
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se tienen pedidos
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div> -->

	
</div>
<app-modal-create-purchase-order *ngIf="createOrder" (close)="closeCreateOrder($event)" (downloadOrderPdf)="downloadOrderPdf($event)"></app-modal-create-purchase-order>
<app-modal-polish-off-order *ngIf="orderShowed" [orderShowed]="orderShowed" (close)="closePolishOff($event)"></app-modal-polish-off-order>
<div class="hide-background" *ngIf="historyShowed">
	<div class="for-click" (click)="resetDeletingDiv()"></div>
	<div class="modal" tabindex="-1" *ngIf="historyShowed">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Historial del pedido</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="historyShowed = null;"></i></h1>
				</div>
				<div class="modal-body">
					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<!-- Cantidad	Producto	Descripcion	Precio	Total -->
									<th class="td-center">
										Fecha
									</th>
									<th class="td-center">
										Usuario
									</th>
									<th>
										Descripción
									</th>
									<th class="td-center">
										Opciones
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let order of historyShowed">
									<td class="td-center">{{convertToString(order.date)}}</td>
									<td class="td-center">{{order.user.email}}</td>
									<td>{{order.description}}</td>
									<td class="td-center" style="max-width: 80px;">
										<span class="clickeable text-info" (click)="historyDetailOrder(order)">
											<i *ngIf="!showingHistoryDetail[order.id]" class="fa-solid fa-eye"></i>
											<span *ngIf="showingHistoryDetail[order.id]"
												class="spinner-border spinner-border-sm" aria-hidden="true"></span>
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="hide-background" *ngIf="historyDetailShowed">
	<div class="for-click" (click)="resetDeletingDiv()"></div>
	<div class="modal" tabindex="-1" *ngIf="historyDetailShowed">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h1>Detalle de Historial de Pedido</h1>
					<h1 style="left: 0;" class="i-hover"><i class="fa fa-xmark" (click)="historyDetailShowed = null;"></i></h1>
				</div>
				<div class="modal-body">
					<div class="table-responsive">
						<table class="table table-striped">
							<thead>
								<tr>
									<th>
										Producto
									</th>
									<th class="td-center">
										Cantidad
									</th>
									<th class="td-center">
										Despachado
									</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="let order of historyDetailShowed">
									<td>{{order.productData.name}}</td>
									<td class="td-center">{{order.detailData.quantity}}</td>
									<td class="td-center">{{order.quantity}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>